import { render } from "./BaseStatusSelect.vue?vue&type=template&id=1fb7d6f0&scoped=true"
import script from "./BaseStatusSelect.vue?vue&type=script&lang=js"
export * from "./BaseStatusSelect.vue?vue&type=script&lang=js"

import "./BaseStatusSelect.vue?vue&type=style&index=0&id=1fb7d6f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb7d6f0"]])

export default __exports__